import customHeaders, { getSpace } from '../../common/headers';
import refresh_icon from './img/refresh_icon.svg';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useParams, useLocation } from 'react-router-dom';
import { useState, useEffect, useCallback, useRef } from 'react';
import { fetchFilterV3 } from '../../common/filtersFunc';
import {
  DropDownSelector,
  SearchComponent,
  Tabs,
  ButtonBasic,
  TableBox,
  Checkbox,
} from '@lk-gtcom/ecomlab-components';
import {
  KonstantinCreateProductHttps,
  KonstantinMasterHttps,
  OlegHttps,
} from '../../fetchUrls';
import './SetPriceAndMarginMasterProduct.scss';
import useGeneralStore from '../../store/general';
import { ModalRules } from '../../components/Modal/ModalRules/ModalRules';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { RequestController } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { periodWeek } from '../../common/constant';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';

const btn_tab = [
  { label: 'Установка цен', value: 'price_setting' },
  { label: 'Правила установки цен', value: 'rules' }
];

const SetPriceAndMarginMasterProduct = () => {
  const activeTab = useParams()['*'];
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };

  const [pageValue, setPageValue] = useState(activeTab || 'price_setting');

  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved,  hasSavedFilters } = useSavedFilters(selectedSpace?.value, pageValue == 'rules' ? 'price-master-product' : 'set-price-margin-master-product')
  const requestControllerRef = useRef(new RequestController());
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const location = useLocation();

  // Фильтры
  const filterConfig = [
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'zero', type: 'single' },
    { key: 'search', type: 'single' },
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);

  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0);

  // Search
  const [defaultSearchValue, setDefaultSearchValue] = useState('')
  const [searchValue, setSearchValue] = useState('');
  const [searchData, setSearchData] = useState([]);
  const [checkedProducts, setCheckedProducts] = useState([]);

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
  const { total } = tableProps;

  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const [checkZero, setCheckZero] = useState(false);

  const [isModal, setIsModal] = useState(false);
  const service_id = 3;
  const [rule_id, setRuleId] = useState(1);
  const [ruleInfo, setRuleInfo] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [ruleName, setRuleName] = useState('');

  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;

  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab]);

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.zero) setCheckZero(urlParams.zero?.value)
        if (urlParams.search) {
          setSearchValue(urlParams.search?.value)
          setDefaultSearchValue({
            value: urlParams.search?.value,
            label: urlParams.search?.label
          })
        }

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady, pageValue]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
    })
  }, [isReady, pageValue]);

  const filtersMasterCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: categoryPage,
      set: setCategoryData,
      searchParam: categoryQuery,
      controller,
      setTotal: setTotalCategory,
      filter: 'mp_categories'
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersMasterBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: brandPage,
      selectedCategory,
      searchParam: brandQuery,
      set: setBrandData,
      controller,
      setTotal: setTotalBrand,
      filter: 'mp_brands'
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersMasterCategory();
  }, [isFilterRequest, categoryPage, categoryQuery, dateFrom, dateTo]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersMasterBrand();
  }, [isFilterRequest, dateFrom, dateTo, brandPage, brandQuery]);

  // Таблица
  const fetchTableData = (params, abortController = new AbortController()) => {
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    setLoading(true);

    let url = `${KonstantinMasterHttps}/master-products/tables/prices${sort?.length > 0
      ? '?order_param=' +
      sort[0] +
      '&order_param_direction=' +
      sort[1] +
      '&without_zero_stock=' +
      checkZero
      : '?without_zero_stock=' + checkZero
      }`;

    let offer_id_name_search = searchValue;

    const body = JSON.stringify({
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
      filters: filtersParam,
      offer_id_name_search,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      });
  };

  const fetchSearch = ([search, page = 1], abortController = new AbortController()) => {
    let url = `${KonstantinMasterHttps}/master-products/filters/offer-id-name`;

    const body = JSON.stringify({
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      page: page,
      limit: 10,
      search_param: search,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setSearchData(json?.filter_data?.map(({ id, name }) => ({ label: name, value: id }))))
      .catch(handleRequestError);
  };

  const fetchUpdatePrices = (abortController = new AbortController()) => {
    let url = `${KonstantinCreateProductHttps}/master_products/prices`;

    const prices = checkedProducts?.map((el) => {
      const { product_id, Артикул, Цена } = el;
      let old_price = +el?.['Цена до скидки'];

      return {
        product_id,
        offer_id: Артикул,
        price: Цена,
        old_price,
        currency: 'RUB',
      };
    });

    const body = JSON.stringify({
      prices,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then(() => setTimeout(() => fetchTableData([]), 100))
      .catch(handleRequestError);
  };

  const handleSaveOnePrice = async (e) => {
    const { inputEvent, actionEvent, setStatus } = e;
    const offerId = inputEvent.id?.[0];
    const productId = actionEvent?.[0]?.product_id;
    const colName = actionEvent?.[2];
    let newPrice;

    newPrice = +inputEvent?.value;

    if (newPrice) {
      setStatus('loading');
      fetchOnePrice(productId, offerId, newPrice, setStatus, colName);
    } else {
      setStatus('error');
    }
  };

  const fetchOnePrice = (productId, articul, newPrice, setStatus, colName) => {
    let url = `${KonstantinCreateProductHttps}/master_products/prices`;

    const prices = [
      {
        obj_to_change: colName === 'Цена' ? 'price' : 'old_price',
        product_id: productId,
        offer_id: articul,
        ...(colName === 'Цена' ? { price: newPrice } : { old_price: newPrice }),
        currency: 'RUB',
      },
    ];

    const body = JSON.stringify({ prices });

    fetch(url, { body, method: 'POST', headers })
      .then((res) => {
        if (res.ok) {
          setStatus('success');
          return res.json();
        } else {
          throw new Error('Failed to save price');
        }
      })
      .then((json) => console.log(json))
      .catch((err) => {
        setStatus('error');
        handleRequestError(err);
      });
  };

  const fetchTableRules = (params) => {
    let sort, filters;
    if (params) {
      [sort, filters] = params;
    }
    setLoading(true);

    const url = `${OlegHttps}/api/v1/${service_id}/client_rule/table`;

    const body = JSON.stringify({
      filters,
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        setLoading(false);
      });
  };

  const onActionHandler = (prop) => {
    const name = prop?.['Название правила'];
    const status = prop?.['Статус'];
    const rule_id = prop?.Rule_id?.[0];
    setRuleInfo({ name, status, rule_id, isEdit: true, isCreate: false });
    setIsModal(true);
  };

  useEffect(() => {
    if (!isReady) return
    const abortController = new AbortController();
    if (pageValue === 'price_setting') {
      resetTable();
      fetchTableData([], abortController);
    } else {
      resetTable();
      fetchTableRules();
    }
    return () => abortController.abort();
  }, [checkZero, pageValue, isTableRequest]);

  const handleSearch = useCallback((e) => {
    const abortController = new AbortController();
    fetchSearch(e, abortController);
    return () => abortController.abort();
  });

  const handleSaveSuccess = () => {
    setIsTableRequest(!isTableRequest)
  };

  return (
    <>
      {isModal &&
        <ModalRules
          isEdit={isEdit}
          setIsEdit={(e) => setIsEdit(false)}
          isCreate={!isEdit}
          {...ruleInfo}
          rule_id={rule_id}
          setRuleIdPar={setRuleId}
          ruleName={ruleName}
          service_id={service_id}
          setRuleInfo={(e) => setRuleInfo(e)}
          setIsModal={setIsModal}
          handleSaveSuccess={handleSaveSuccess}
        />
      }

      <div className="set-price-and-margin-master-product">
        <TitlePage
          title={pageValue == 'rules' ? 'Цены мастер товаров' : 'Установка цен мастер товаров'}
        />

        <FilterContainer
          loading={isSaved}
          saveFilters={saveFilters}
          clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
          onReset={(e) => {
            setSelectedCategory([]);
            setSelectedBrand([]);
            resetTable();
            updateURL({
              category: null,
              brand: null,
              search: null,
            });
            setIsTableRequest(!isTableRequest)
            setIsFilterRequest(!isFilterRequest);
          }}
        >
          <DropDownSelector
            options_prop={categoryData}
            state={selectedCategory}
            setState={setSelectedCategory}
            placeholder="Категория"
            total={totalCategory}
            multi={true}
            fetchCallback={setCategoryPage}
            setInputChange={setCategoryQuery}
            onBlur={() => {
              updateURL({ category: selectedCategory });
              filtersMasterBrand();
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={brandData}
            state={selectedBrand}
            setState={setSelectedBrand}
            placeholder="Бренд"
            total={totalBrand}
            multi={true}
            fetchCallback={setBrandPage}
            setInputChange={setBrandQuery}
            onBlur={() => {
              updateURL({ brand: selectedBrand });
              setIsTableRequest(!isTableRequest)
            }}
          />

          {pageValue != 'rules' && (
            <SearchComponent
              searchValue={searchValue}
              errSearch={false}
              placeholder="Искать по артикулу или названию"
              errText="Неверный артикул или название"
              setSearchValue={setSearchValue}
              fetchData={(e) => setIsTableRequest(!isTableRequest)}
              fetchCallback={handleSearch}
              data={searchData}
              onClearDependence={[isFilterRequest]}
              updateURL={updateURL}
              value={defaultSearchValue}
            />
          )}
          <Checkbox
            value={checkZero}
            onChange={(e) => {
              updateURL({
                zero: {
                  label: e,
                  value: e
                }
              });
              setCheckZero(e)
            }}>
            Без нулевого остатка
          </Checkbox>
        </FilterContainer>

        <Tabs
          tabs={btn_tab}
          pageValue={pageValue}
          query={location?.search}
        />

        {pageValue === 'price_setting' ?
          <TableBox
            {...tableProps}
            paginator={true}
            ref={paginatorRef}
            onCheck={(e) => setCheckedProducts(e)}
            fetchCallback={fetchTableData}
            onInputAction={(e) => handleSaveOnePrice(e)}
            child={
              <ButtonBasic
                violet
                text={'Обновить цены'}
                icon={refresh_icon}
                onClick={(e) => {
                  if (pageValue == 'rules') {
                    setIsModal(true);
                  }
                }}
                width="auto"
                size="32px"
              />}
          />
          :
          <TableBox
            onAction={(e) => {
              const ruleId = e['Идентификатор правила']
                ? e['Идентификатор правила']
                : null;
              onActionHandler(e);
              setRuleId(Number(ruleId));
            }}
            ref={paginatorRef}
            paginator={true}
            fetchCallback={(e) => fetchTableRules(e)}
            {...tableProps}
            statistic={[
              {
                label: 'Правил',
                sum: total,
              },
            ]}
            child={
              <ButtonBasic
                violet
                text={'+ Добавить правило'}
                onClick={(e) => {
                  if (pageValue == 'rules') {
                    setIsModal(true);
                  }
                }}
                width="auto"
                size="32px"
              />}
          />
        }
      </div>
    </>
  );
};

export { SetPriceAndMarginMasterProduct };
